import { render, staticRenderFns } from "./ProjectPurchaseOrderListing.vue?vue&type=template&id=5a438814"
import script from "./ProjectPurchaseOrderListing.vue?vue&type=script&lang=js"
export * from "./ProjectPurchaseOrderListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports